import { render, staticRenderFns } from "./SelfPageFollowing.vue?vue&type=template&id=2050474b&scoped=true&"
import script from "./SelfPageFollowing.vue?vue&type=script&lang=js&"
export * from "./SelfPageFollowing.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/main.css?vue&type=style&index=0&id=2050474b&lang=css&scoped=true&"
import style1 from "./SelfPageFollowing.vue?vue&type=style&index=1&id=2050474b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2050474b",
  null
  
)

export default component.exports